var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanericon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3647 0.883789C7.50439 0.883789 7.64409 0.914158 7.77164 0.971859L13.4901 3.39833C14.1582 3.68076 14.6562 4.33976 14.6532 5.13542C14.638 8.14801 13.399 13.6599 8.16643 16.1654C7.65927 16.4083 7.07012 16.4083 6.56296 16.1654C1.33042 13.6599 0.0913701 8.14801 0.0761857 5.13542C0.0731488 4.33976 0.571197 3.68076 1.23931 3.39833L6.96079 0.971859C7.0853 0.914158 7.225 0.883789 7.3647 0.883789ZM7.3647 2.91242V14.3918C11.5556 12.3632 12.6823 7.87165 12.7096 5.17794L7.3647 2.91242Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanericon1);
export default __webpack_public_path__ + "static/media/banericon1.e528624232cfb270b5574e8c61ffac43.svg";
export { ForwardRef as ReactComponent };